import { put, select, takeLatest } from 'redux-saga/effects';

import forEach from 'lodash/forEach';

import { formatError } from '../../../libs';
import { Types, Creators as CategoryCreators } from '../../reducers/category';
import getState from '../../utils/getState';

function* getFilteredItems() {
  try {
    const {
      category: { searchQuery, filters },
    } = yield select(getState);
    const filteredItems = [];

    forEach(searchQuery.getIn(['filter']), (item) => {
      if (item.id !== 'categoria') {
        forEach(item, (subItem) => {
          const sideBarItem = filters.getIn(['sidebar']).find((sbItem) => sbItem.id === subItem.id);

          if (sideBarItem) {
            filteredItems.push(sideBarItem.options.find((option) => option.value === subItem.value));
          }
        });
      }
    });

    yield put(CategoryCreators.getFilteredItemsSuccess(filteredItems));
  } catch (error) {
    yield put(CategoryCreators.getFilteredItemsError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.GET_FILTERED_ITEMS_REQUEST, getFilteredItems);
}
